import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { applyDocumentDirForPath } from './i18n'
import './assets/css/tailwind.css'
// import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/accessibility.css'

// Set <html lang/dir> before mount — לפי המסלול הנוכחי, לא רק לפי השפה השמורה:
// מחוץ לממשק הגן/מנהל התוכן עברית, ולכן lang/dir נשארים he/rtl. (docs/features/i18n.md)
applyDocumentDirForPath(window.location.pathname)

createApp(App).use(router).use(i18n).mount('#app')
